import './changes-history.scss';
import template from './changes-history.html';

class ChangesHistoryComponent {}

export const ChangesHistory = {
  bindings: {
    changes: '<'
  },
  controller: ChangesHistoryComponent,
  template
};
